import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { errMsg } from '../../lib/aiInterviewApi';
import { schedulingAPI } from '../../lib/schedulingApi';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import { Pill } from '../aiinterview/recruiter/common';

export default function PoolDialog({ open, onOpenChange, pool, team, onSaved }) {
  const [name, setName] = useState('');
  const [desc, setDesc] = useState('');
  const [sel, setSel] = useState(new Set());
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!open) return;
    setName(pool?.name || '');
    setDesc(pool?.description || '');
    setSel(new Set(pool?.member_ids || []));
  }, [open, pool]);
  const toggle = (id) => setSel((s) => { const n = new Set(s); n.has(id) ? n.delete(id) : n.add(id); return n; });
  const save = async () => {
    setBusy(true);
    try {
      const body = { name, description: desc, member_ids: [...sel] };
      if (pool) await schedulingAPI.updatePool(pool.id, body);
      else await schedulingAPI.createPool(body);
      toast.success(pool ? 'Pool updated' : 'Pool created');
      onOpenChange(false);
      onSaved();
    } catch (e) {
      toast.error(errMsg(e, 'Could not save the pool'));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="iv sc-dialog max-w-lg" data-testid="pool-dialog">
        <DialogHeader>
          <DialogTitle>{pool ? 'Edit interviewer pool' : 'New interviewer pool'}</DialogTitle>
          <DialogDescription>Interviews booked from a pool are shared out fairly: the free interviewer with the fewest recent interviews gets the next one.</DialogDescription>
        </DialogHeader>
        <input className="iv-input" placeholder="Pool name, e.g. Backend panel" value={name} onChange={(e) => setName(e.target.value)} data-testid="pool-name-input" />
        <input className="iv-input" placeholder="Description (optional)" value={desc} onChange={(e) => setDesc(e.target.value)} data-testid="pool-desc-input" />
        <div className="iv-eyebrow" style={{ marginTop: '0.4rem' }}>Interviewers ({sel.size})</div>
        <div className="sc-members" data-testid="pool-member-list">
          {(team || []).map((m) => (
            <label key={m.id} className="iv-status" style={{ cursor: 'pointer', margin: 0 }}>
              <span className="iv-row" style={{ gap: '0.6rem' }}>
                <input type="checkbox" checked={sel.has(m.id)} onChange={() => toggle(m.id)} data-testid={`pool-member-${m.id}`} />
                <span><b>{m.name || m.email}{m.is_me ? ' (you)' : ''}</b><span className="iv-small" style={{ display: 'block' }}>{m.email}</span></span>
              </span>
              <span className="iv-row" style={{ gap: '0.3rem' }}>
                {!m.hours_set && <Pill tone="amber">Default hours</Pill>}
                {m.calendar && <Pill tone="green">{m.calendar === 'google' ? 'Google' : 'Outlook'}</Pill>}
              </span>
            </label>
          ))}
        </div>
        <div className="iv-row-end">
          <button type="button" className="iv-btn iv-btn-ghost" onClick={() => onOpenChange(false)}>Cancel</button>
          <button type="button" className="iv-btn iv-btn-primary" disabled={busy || !name.trim() || !sel.size} onClick={save} data-testid="pool-save-btn">{busy ? 'Saving…' : 'Save pool'}</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
